import { apiClient } from '@/lib/api/api-client';

export interface ImportTaxConfig {
  importTaxRate: number;
  importInternacionRate: number;
}

const BASE = '/api/import-tracking/tax-config';

export const importTaxConfigService = {
  get: () => apiClient.get<ImportTaxConfig>(BASE),
  update: (data: Partial<ImportTaxConfig>) => apiClient.patch<ImportTaxConfig>(BASE, data),
};
